import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Loader from "../../Layout/Loader";
import mainAxios from "../../../services/mainAxios";
import { useTranslation } from "react-i18next";
import { useAppContext, usePersistedState } from "../../../AppContext";
import CellInput from "../../global/CellInput";
import PrimeTable from "../../PrimeTable/PrimeTable";
import AddUser from "./AddUser";
import { Dialog } from "primereact/dialog";
import { toast } from "react-toastify";
import CisMessage from "../../global/CisMessage";
import ExportCsvPrime from "../../global/ExportCsvPrime";
const moment = require("moment");

const OperatorsCis = ({company}) => {
  const { user: [user], selectedCompany: [selectedCompany] } = useAppContext();
  const [users, setOperatorsCis] = React.useState(null);
  const [operatorsCisForCsv, setOperatorsCisForCsv] = useState([]);
  const { t, i18n } = useTranslation("translations");
  const [openAddUser,setOpenAddUser]=useState({visible:false,data:null})
  const [cisLoading,setCisLoading]=useState(false)
  const defaultSortCriteria={
    field: "recordDate",
    direction: "DESC"
  }
  const [tableRows, setTableRows] = useState({
    totalRows: 0,
    rowsPerPage: 10,
    currentPage: 1,
    sortCriteria:defaultSortCriteria
  });

  const defaultFilters = { params: {} }
  const [filters, setFilters] = React.useState(defaultFilters);

  React.useEffect(() => {
    if (company?.id) {
      getOperatorsCisResults(10, 1);
    }
  }, [selectedCompany, company?.id]);



  const getOperatorsCisResults = ({ updatedFilters,rowsPerPage = 10, currentPage = 1, exportCsv = false, sortCriteria = [ defaultSortCriteria ], } = {}) => {
    if (!company?.id) return;
    let compId = company?.id
    let requestBody = {
      object: "GetOperatorCis",
      nuis:company?.nuis,
      company:compId,
      sortCriteria,
      params:updatedFilters?.params,
      pagination: exportCsv ? null : {
        pageSize: rowsPerPage,
        pageNumber: currentPage,
      },
    };
    return mainAxios.post(
      // apiEndpoint/search
      "/apiEndpoint/search"
      , requestBody).then((res) => {
      if (res?.data?.status === true) {
          if (exportCsv) {
            setOperatorsCisForCsv(res.data.content)
            return res.data.content
          } else {
            setOperatorsCis(res.data.content);
            //set total rows from totalSize of response
            setTableRows((tableRows) => ({
              ...tableRows,
              totalRows: res?.data?.totalSize,
            }));
          }
      }
      return null
    });
  };

  const onAddUser=(e,cisUser)=>{
    e.preventDefault();
    const {operatorFirstName:firstName,operatorLastName:lastName,}=cisUser
    const username=(firstName?.[0] ?? "")+(lastName ?? "")
    const user={
      firstName,lastName,username
    }
    setOpenAddUser({visible:true,data:user})
  }

  const addUserBody=(user)=>{
    return (
      <Link onClick={e=>onAddUser(e,user)} className="table-action-link" to="#">
        <FontAwesomeIcon icon={faPlus} />
        {t("selfServices.addProfiscUser")}
      </Link>
    )
  }

  const actions= [{
    header: t(["home.actions"]),
    field: "actions",
    style:{minWidth:"180px",maxWidth:"180px"},
    body: addUserBody,
    default:true,
    mobile: { priority: "action", group: "actions" },
  }]


  const columnsWoAction = [

    {
      header: t(["users.firstName"]),
      field: "operatorFirstName",
      filter: true,
      sortable: true,
      default:true,
      style:{minWidth:"150px",maxWidth:"150px"},
      body: (invoice) => <CellInput width={80} value={invoice?.operatorFirstName ?? ""} />,
      mobile: { priority: 1, isTitle: true, group: "identity" },

    },
    {
      header: t(["users.lastName"]),
      field: "operatorLastName",
      sortable: true,
      default:true,
      filter: true,
      style:{minWidth:"150px",maxWidth:"150px"},
      body:(invoice)=><CellInput width={80} value={invoice?.operatorLastName ?? ""}/>,
      mobile: { priority: 1, group: "identity" },

    },
    {
      header: t("table.operatorid"),
      field: "operatorId",
      default:true,
      sortable: true,
      filter: true,
      style:{minWidth:"170px",maxWidth:"180px"},
      body:(invoice)=><CellInput width={80} value={invoice?.operatorId ?? ""}/>,
      mobile: { priority: 1, group: "identity" },

    },
    {
      header: "Operator Valid From",
      field: "operatorValidFrom",
      default:true,
      style:{minWidth: "200px",maxWidth:"200px"},
      sortable: true,
      formattedExportValue: true,
      body: (user) =>
        user?.operatorValidFrom
          ? moment(user?.operatorValidFrom).format("DD/MM/YYYY HH:mm")
          : "",
      mobile: { priority: 1, group: "dates" },
    },
    {
      header: "Operator Valid To",
      default:true,
      field: "operatorValidTo",
      style:{minWidth: "200px",maxWidth:"200px"},
      sortable: true,
      formattedExportValue: true,
      body: (user) =>
        user?.operatorValidTo
          ? moment(user?.operatorValidTo).format("DD/MM/YYYY HH:mm")
          : "",
      mobile: { priority: 1, group: "dates" },
    },
    {
      header: t("company.cisUpdate"),
      field: "cisLastUpdate",
      style:{minWidth: "260px",maxWidth:"300px"},
      sortable: true,
      default:true,
      formattedExportValue: true,
      body: (user) =>
        user?.cisLastUpdate
          ? moment(user?.cisLastUpdate).format("DD/MM/YYYY HH:mm")
          : "",
      mobile: { priority: 1, group: "dates" },
    },
    {
      header: "Missing From CIS",
      field: "missingFromCis",
      style:{minWidth: "200px",maxWidth:"200px"},
      sortable: true,
      default:true,

      // body: (user) => (user?.missingFromCis ? t(["company.yes"]) : t(["company.no"])),
      // body: (user) => actions(user, "missingFromCis"),
      filter:true,
      filterType:"TRISTATECHECKBOX",
      dataType:"boolean",
      mobile: { priority: 1, isBadge: true, group: "status" },
    },
    {
      header: t(["invoice.Operator"]),
      field: "operatorCode",
      default:true,
      style:{minWidth: "150px",maxWidth:"150px"},
      filter: true,
      sortable: true,
      mobile: { priority: 1, group: "reference" },
    },
  ];

  const columns=user?.role?.id == 1 ?actions.concat(columnsWoAction) : columnsWoAction


      const [selectedColumns, setSelectedColumns] = usePersistedState(
          columns.map((col) => ({ field: col.field, show: !!col.default, ...(col?.persisted ? { persisted: true } : {}) })),
          "cisColumns"
      );

  if (!users || !company?.id) return <Loader />

  const refreshDataFromCos=()=>{
    if (!company?.id) return;
    setCisLoading(true)
    mainAxios.post("/endpoint/v3/getDataFromCis",{
        object: "GetOperator",
        nuis:company?.nuis,
        company:company?.id
    }).then(res=>{
        setCisLoading(false)
      if(res.data.status){
        getOperatorsCisResults(10,1)
          toast.success(t(['purchases.defaultAction']), {
              containerId: "all_toast"
          })
      }
    })
    .catch(err=>{
        setCisLoading(false)
    })
}


  const headerButtonsRight=(
    <div className='prime-table-toolbar__add-btn' onClick={() => { if (!cisLoading) refreshDataFromCos()}} style={cisLoading ? {opacity: 0.6, pointerEvents: 'none'} : {}}>
      {cisLoading ? <Loader size={"xs"}/> : "Get Operators From CIS"}
    </div>
  )

  const headerButtonsLeft=(<CisMessage requestBody={{
    object:"GetCompanyInfoRequestLogV",
    params:{
      type:"OPERATOR"
    },
    company: company.id
  }} />)

  const headerIcons = (
    <ExportCsvPrime
      selectedColumns={selectedColumns}
      iconOnly
      tooltip="Export CSV"
      data={operatorsCisForCsv}
      columns={columns}
      onClick={() => getOperatorsCisResults({ updatedFilters: filters, exportCsv: true })}
      excludedColumns={["actions"]}
    />
  )

  return (
    <>
      <Dialog
        header={t('users.add')}
        visible={openAddUser.visible}
        onHide={() => setOpenAddUser({ visible: false, data: null })}
        style={{ width: "30vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      >
        {openAddUser.visible &&<AddUser
          defaultUser={openAddUser?.data ?? null}
        />}
      </Dialog>
      <PrimeTable
        stripedRows={false}
        filters={[filters, setFilters]}
        defaultFilters={defaultFilters}
        tableRows={[tableRows, setTableRows]}
        value={users ?? []}
        columns={columns}
        reorderableColumns={true}
        showFilters={true}
        filterDisplay={"row"}
        responsiveLayout="scroll"
        showHeader={true}
        dataKey="id"
        showSelectColumns
        gridKey="cisColumns"
        selectedColumns={[selectedColumns, setSelectedColumns]}
        onRemoteDataChange={(remoteData) => {
          const updatedFilters = remoteData.filters ?? filters
          const updatedTableData = remoteData.tableRows ?? tableRows
          let { currentPage, rowsPerPage,sortCriteria } = updatedTableData
          sortCriteria=sortCriteria?[sortCriteria]:null
          getOperatorsCisResults({updatedFilters, rowsPerPage, currentPage, sortCriteria })
        }}
        defaultSortCriteria={defaultSortCriteria}
        clearFilters={true}
        headerButtonsRight={headerButtonsRight}
        headerButtonsLeft={user?.role?.id != 3 && headerButtonsLeft}
        headerIcons={headerIcons}
        />
    </>
  )
};

export default OperatorsCis;
